jQuery(document).ready(function($) {
    $('.js-share').each((index, el) => {
        let title = $(el).data('title');
        let link = $(el).data('url');
        let summary = $(el).data('summary');
        let facebookUrl = "https://www.linkedin.com/sharing/share-offsite?title=" + encodeURI(title) + "&summary=" + encodeURI(summary) + "&url=" + encodeURI(link);
        let twitterUrl = "https://x.com/intent/tweet?text=" + encodeURIComponent(title) + " - " + encodeURI(link);
        let shareToFacebook = (ev) => {
            ev.preventDefault();
            window.open("https://www.facebook.com/sharer/sharer.php?u=" + encodeURI(link), "pop", "width=600, height=400, scrollbars=no");
        }
        let shareToLinkedin = (ev) => {
            ev.preventDefault();
            window.open(facebookUrl, "pop", "width=600, height=400, scrollbars=no");
        }
        let shareToXTwitter = (ev) => {
            ev.preventDefault();
            window.open(twitterUrl, "pop", "width=600, height=400, scrollbars=no");
        }
        $('.js-share--fb', el).on('click', shareToFacebook);
        $('.js-share--linkedin', el).on('click', shareToLinkedin);
        $('.js-share--x', el).on('click', shareToXTwitter);
        $('.js-share-copy', el).on('click', (ev) => {
            ev.preventDefault();
            navigator.clipboard.writeText(link);
            $('.js-share-copy', el).addClass('u-feedback-effect');
            setTimeout(function () {
                $('.js-share-copy', el).removeClass('u-feedback-effect');
            }, 500);
        });
    });
})